import { InputNumber, Select, type InputNumberProps } from "antd";
import styles from "./style.module.less";

interface SeedRateInputProps
  extends Pick<
    InputNumberProps<number>,
    | "value"
    | "onChange"
    | "status"
    | "disabled"
    | "readOnly"
    | "aria-label"
    | "aria-invalid"
    | "aria-describedby"
  > {
  options?: number[];
}

const SeedRateInput = ({
  options = [],
  disabled,
  readOnly,
  ...props
}: SeedRateInputProps): JSX.Element =>
  options.length > 0 ? (
    <Select<number>
      {...props}
      className={styles.select}
      value={props.value ?? undefined}
      options={options.map((rate) => ({ label: String(rate), value: rate }))}
      disabled={readOnly === true ? true : disabled}
      onChange={(rate) => props.onChange?.(rate)}
    />
  ) : (
    <InputNumber<number>
      {...props}
      disabled={disabled}
      readOnly={readOnly}
      controls
    />
  );

export default SeedRateInput;
